<div *ngIf="isWatchlistDataLoaded" class="watchlist-dropdown">
  <nz-select
    nzPlaceHolder="Select Watchlist"
    nzDropdownClassName="watchlist-dropdown-overlay"
    [(ngModel)]="watchlistId"
    [nzBackdrop]="true"
    (ngModelChange)="selectWatchlist()"
    style="width: 100%;"
  >
    <nz-option
      *ngFor="let watchlist of watchlistDD"
      [nzValue]="watchlist.w_id"
      [nzLabel]="watchlist.w_displayname"
    >
    </nz-option>
  </nz-select>
</div>
